import { DEVICE_OS } from "./detail/general/redux/types"


 function getStandbyStatus(standByValue: string, os: string) {
    if (os === DEVICE_OS.HORIZON) {
      return standByValue === 'Standby' ? 'Standby' : 'On'
    }

    return standByValue === 'off' ? 'Standby' : 'On'
  }

  export function validConnected(connected: string, standBy: string, os: string, label: string) {
    if (connected === label) {
      return connected
    }

    if (connected === 'true') {
      return getStandbyStatus(standBy, os)
    }

    return 'Off'
  }

  export function getDeviceOs(brandId: string) {
    const brandIdParsed = Number(brandId)
    const androidDevicesBrandsId = [346, 347, 362]
    if(androidDevicesBrandsId.includes(brandIdParsed)) {
      return DEVICE_OS.ANDROID
    }

    const horizonDevicesBrandsId = [334, 335]
    if(horizonDevicesBrandsId.includes(brandIdParsed)) {
      return DEVICE_OS.HORIZON
    }

    return DEVICE_OS.LINUX
  }